/**
 * Help text for editor fields. Ported from GSA openacr-editor src/data/helpText.yaml
 */
export default {
  product: {
    name: "",
    version: "Provide version if available.",
    description: "Describe the general offering. This should not be specific to a contract or RFP.",
  },
  author: {
    name: "Contact name or team representing author of the ACR.",
    company_name: "Name of the accessibility agency that wrote the ACR.",
    address: "Street address for accessibility agency.",
    email: "Include a contact email for questions or feedback on the ACR.",
    phone: "Accessibility agency phone number.",
    website: "Website for accessibility agency.",
  },
  vendor: {
    name: "Contact name or team representing the vendor.",
    company_name: "Name of the vendor who is responsible for the offering or is submitting the the ACR.",
    address: "Street address for vendor.",
    email: "Include a contact email for questions or feedback on the ACR.",
    phone: "Vendor phone number.",
    website: "Website for the vendor or offering.",
  },
  report: {
    report_date: "",
    last_modified_date: "Last modified date is a read-only field that is automatically updated.",
    version: "Version is a read-only field that is automatically updated when report is uploaded.",
    notes: "Any comments that you would like to add for the report. This can include related projects.",
    evaluation_methods_used:
      "Please describe in detail how this report was created. What tools and processes were used. How many and what type of pages were evaluated, along with anything else which would provide context.",
    legal_disclaimer:
      "Optional field for legal disclaimer. Please list license here if it is not released under an open license.",
    repository: "URL for the git repository that contains the ACR.",
    feedback: "Details about feedback from author.",
    license: "If this is released under an open license.",
  },
  chapters: {
    notes: "",
  },
  components: {
    level: "",
    notes: "",
  },
  related_acrs: {
    intro: "URLs to related ACR reports. E.g. CKEditor is a library used by Drupal and both have ACR reports.",
    url: "",
    type: "",
  },
  disabled_chapters: {
    intro:
      "Select which chapters/tables of the ACR report you want to disable. They can be reenabled at any time. Fields on those chapters/tables will also be disabled except for notes. The table will also be removed from the report and HTML but the data will still be available in the YAML format.",
    success_criteria_level_a: "",
    success_criteria_level_aa: "",
    success_criteria_level_aaa: "",
    functional_performance_criteria: "",
    hardware: "",
    software: "",
    support_documentation_and_services: "",
  },
  catalog: {
    intro: "Select which catalog you want to use for this ACR report.",
    "2.4-edition-wcag-2.0-508-en":
      "These are the minimum standards required for Section 508 conformance in the United States of America.",
    "2.4-edition-wcag-2.1-en":
      "This is a web-specific ACR that follows the global best practices for web accessibility.",
    "2.4-edition-wcag-2.1-508-en":
      "This is the current best practice standard in the United States of America.",
  },
};
